import { EErrorLevel, logger } from '@web_opxp/features';
import { GalleryUrlWhitelist } from '../../base/env';
import { IEvent, IJsonEvent } from './types';

export function getUniqueCategories(events: IEvent[]) {
  const set = new Set<string>();
  events.forEach((e) => e.categories.forEach((c) => set.add(c)));
  return Array.from(set);
}

export const filterEvents = (events: IEvent[], categoryFilter?: string, presenterFilter?: string): IEvent[] => {
  return events.filter((event) => {
    const matchesCategory = !categoryFilter || event.categories.includes(categoryFilter);
    const matchesPresenter = !presenterFilter || event.presenterName === presenterFilter;
    return matchesCategory && matchesPresenter;
  });
};

export const convertJsonEventListToIevent = (data: IJsonEvent[]): IEvent[] => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.map((item) => ({
    id: item.Id,
    title: item.Title,
    categories: item.Categories.split(',').map((cat: string) => cat.trim()),
    description: '', // Json does not provide description
    videoURL: item.VideoURL,
    thumbnailURL: item.ThumbnailURL,
    pageURL: item.PageURL,
    quizURL: item.QuizURL,
    presenterImageURL: item.PresenterImageURL,
    presenterName: item.PresenterName,
    presenterDescription: item.PresenterDescription,
  }));
};

export function parentRefresh() {
  const height = document.body.scrollHeight;
  window.parent.postMessage({ frameHeight: height }, '*');
}

function sanitizeUrl(url: string): string {
  const fallbackUrl = `https://${GalleryUrlWhitelist[0]}`;
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol !== 'https:') {
      return fallbackUrl;
    }
    const hostname = parsedUrl.hostname.toLowerCase();
    const isAllowedDomain = GalleryUrlWhitelist.some((allowedDomain) => {
      const allowed = String(allowedDomain).toLowerCase();
      return hostname === allowed || hostname.endsWith('.' + allowed);
    });
    if (!isAllowedDomain) {
      logger(`Blocked URL from disallowed domain: ${parsedUrl.hostname}`, EErrorLevel.Log);
      return fallbackUrl;
    }
    return parsedUrl.href;
  } catch (e) {
    logger(`Invalid URL encountered: ${url}`, EErrorLevel.Log);
    return fallbackUrl;
  }
}

export function sanitizeEventUrls(events: IEvent[]): IEvent[] {
  return events.map((event) => ({
    ...event,
    videoURL: sanitizeUrl(event.videoURL),
    thumbnailURL: sanitizeUrl(event.thumbnailURL),
    pageURL: sanitizeUrl(event.pageURL),
    presenterImageURL: sanitizeUrl(event.presenterImageURL),
  }));
}
